import { Category } from './../../../models/category.models';
import { Product } from './../../../models/product.models';
import { Client } from './../../../models/client.models';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ParametrosService } from 'app/services/parametros.service';
import { ProductoService } from 'app/services/producto.service';
import { BarcodeValidator } from 'app/validators/barcodeValidator';
import { ActivatedRoute, Router } from '@angular/router';
import { Brand } from 'app/models/brand.models';
import Swal from 'sweetalert2';
import { ArchivosService } from 'app/services/archivos.service';
import { MatDialog } from '@angular/material/dialog';
import { VariantesArticuloComponent } from '../variantes-articulo/variantes-articulo.component';
import { UploadImage } from 'app/interfaces/upload-images.interface';
import { Variant } from 'app/models/variant.models';
import { MatTableDataSource } from '@angular/material/table';
import { AuthService } from 'app/services/auth.service';
import { CondicionIva } from 'app/models/condicionfrenteiva.models';
import { ArticlesType } from 'app/models/tipo-articulo.models';
import { MeasurementUnit } from 'app/models/umedida.models';
import { ConversionUnitsDialogComponent } from './conversion-units-dialog/conversion-units-dialog.component';
import { ConversionUnits } from 'app/models/conversion-unit.models';
import { CompositeArticleVariant } from 'app/models/composite-article-variant.models';
import { SelectionModel } from '@angular/cdk/collections';
import { ComponenteDialogoComponent } from './componente-dialogo/componente-dialogo.component';
import { Currencie } from 'app/models/currencie.models';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { ProveedorTabComponent } from './proveedor-tab/proveedor-tab.component';
import { Warehouse } from 'app/models/warehouse.models';
import { AlmacenService } from 'app/services/almacen.service';
import { ArticuloProveedorService } from 'app/services/articuloproveedor.service';
import { CreateMarcaComponent } from '../../settings/marcas/create-marca/create-marca.component';
import { CreateRubroComponent } from '../../settings/rubros/create-rubro/create-rubro.component';
import { Tributo } from 'app/models/tributo.models';
import { ImpuestosDialogComponent, ProductTax } from './impuestos-dialog/impuestos-dialog.component';
import { InfoDialogComponent, InfoDialogData } from './info-dialog/info-dialog.component';
import { EmpresaService } from 'app/services/empresa.service';
import { Company } from 'app/models/company.models';

@Component({
  selector: 'app-detalle-producto',
  templateUrl: './detalle-producto.component.html',
  styleUrls: ['./detalle-producto.component.css'],
})
export class DetalleProductoComponent implements OnInit {
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  @ViewChild('nameInput') nameInput: ElementRef;
  @ViewChild('tabGroup') tabGroup: MatTabGroup;

  medidas: MeasurementUnit[] = [];
  typeivas: CondicionIva[] = [];
  listaprecios = [];
  monedas: Currencie[] = [];
  rubros: Category[] = [];
  marcas: Brand[] = [];
  almacenes: Warehouse[] = [];
  form: UntypedFormGroup;

  // Variables para el autocompletado
  medidasFiltradas: Observable<MeasurementUnit[]>;
  rubrosFiltrados: Observable<Category[]>;
  marcasFiltradas: Observable<Brand[]>;
  producto: Product;
  textoBtn: string;
  idProducto: number;
  verStock = true;
  editNombre = false;
  verVariante = false;
  isImgsToRecoverActive = false;
  isLoading: boolean = false;
  variantes: Variant[] = [];
  list: any[] = [];
  listNoImg: number[];
  listImgCopy: any[] = [];
  dataSource: MatTableDataSource<Variant> = new MatTableDataSource();
  displayedColumns: string[] = ['nombre', 'stock', 'precio', 'accion'];
  listSinModificar: any[] = [];
  operadores = [];
  tiposarticulos: ArticlesType[] = [];
  selected_star: boolean = false;
  selectedIndexMainImage: number;
  idVariant: number | null;
  conversionUnits: ConversionUnits[] = [];

  // Para gestionar productos compuestos
  componentesForm: UntypedFormGroup;
  variantesDisponibles: Variant[] = [];
  componentesDataSource: MatTableDataSource<CompositeArticleVariant> = new MatTableDataSource();
  displayedColumnsComponentes: string[] = ['nombre', 'cantidad', 'accion'];
  selectedComponentVariant: Variant | null = null;
  selection = new SelectionModel<Variant>(true, []);
  errorComponentes = false;
  mensajeErrorComponentes = '';

  // Nueva propiedad para gestionar el estado de edición del código
  isEditingCode: boolean = false;
  
  // Variables simples para controlar errores de código de barras
  barcodeHasError: boolean = false;
  barcodeErrorMessage: string = '';

  // Variables para manejar proveedores temporales en productos nuevos
  tempProveedores: Client[] = [];
  isNewProduct: boolean = false;

  // Variables para manejar impuestos (delegado al diálogo)
  productTaxes: ProductTax[] = []; // Impuestos agregados al producto

  // Variables para evitar bucles infinitos en calculadora de precios
  private calculatingForward = false; // Indica si se está calculando hacia adelante (costo -> PVP)
  private calculatingBackward = false; // Indica si se está calculando hacia atrás (PVP -> margen)
  private loadingProductData = false; // Indica si se están cargando datos del producto desde el backend
  private calculatingPurchaseForward = false; // Indica si se está calculando desde costo sin IVA -> con IVA
  private calculatingPurchaseBackward = false; // Indica si se está calculando desde costo con IVA -> sin IVA

  // Variable para controlar la vista avanzada de precios
  showAdvancedPricing = false; // false = vista simplificada (por defecto), true = vista avanzada

  // Variables para información de la empresa
  empresaInfo: Company | null = null;
  isMonotributista: boolean = false;

  // Validadores personalizados
  static requiredSelect(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value === null || value === undefined || value === '' || value === 0) {
      return { requiredSelect: true };
    }
    return null;
  }

  static numericRequired(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value === null || value === undefined || value === '' || value === 0 || isNaN(Number(value))) {
      return { numericRequired: true };
    }
    return null;
  }

  // Función de utilidad para redondear precios a 2 decimales
  private roundToTwoDecimals(value: number | string): number {
    const numValue = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(numValue)) return 0;
    return Math.round(numValue * 100) / 100;
  }

  // Getter para verificar si el formulario es válido para guardar
  get canSave(): boolean {
    // Validaciones básicas requeridas para todos los tipos
    const nameValid = this.form.get('name')?.valid && this.form.get('name')?.value?.trim();
    const measurementUnitValid = this.form.get('measurementUnitId')?.valid && this.form.get('measurementUnitId')?.value;
    const ivaRateValid = this.form.get('ivaRateId')?.valid && this.form.get('ivaRateId')?.value;
    const currencyValid = this.form.get('currencyId')?.valid && this.form.get('currencyId')?.value;
    const codeValid = this.form.get('code')?.valid || this.form.get('code')?.disabled;

    const typeControl = this.form.get('type');
    const isProducto = typeControl?.value === 'producto';

    // Validaciones de marca y rubro (SOLO obligatorias para productos)
    let brandValid = true;
    let categoryValid = true;
    
    if (isProducto) {
      brandValid = this.form.get('brandId')?.valid &&
        this.form.get('brandId')?.value &&
        this.form.get('brandId')?.value !== '' &&
        this.form.get('brandId')?.value !== 0;

      categoryValid = this.form.get('categoryId')?.valid &&
        this.form.get('categoryId')?.value &&
        this.form.get('categoryId')?.value !== '' &&
        this.form.get('categoryId')?.value !== 0;
    }
    // Para servicios, marca y rubro son opcionales

    // Validar código de barras solo para productos
    const barcodeControl = this.form.get('barCode');
    let barcodeValid = true;
    
    if (isProducto && barcodeControl?.enabled) {
      // Para productos, si hay valor, debe ser válido
      barcodeValid = !barcodeControl?.value || barcodeControl.valid;
    }
    // Para servicios, no validamos el código de barras

    // Campos básicos válidos
    const basicFieldsValid = nameValid && measurementUnitValid && ivaRateValid && currencyValid && codeValid;

    return basicFieldsValid && brandValid && categoryValid && barcodeValid;
  }

  constructor(
    private fb: UntypedFormBuilder,
    private _snackBar: MatSnackBar,
    private parametroServicio: ParametrosService,
    private productoService: ProductoService,
    private router: Router,
    private routerActive: ActivatedRoute,
    private archivoService: ArchivosService,
    private authService: AuthService,
    private articuloProveedorService: ArticuloProveedorService,
    private empresaService: EmpresaService,
    public dialog: MatDialog
  ) {
    this.idProducto = this.routerActive.snapshot.params.id;
    this.isNewProduct = !this.idProducto; // Determinar si es un producto nuevo
    this.form = this.fb.group({
      code: ['', Validators.required],
      name: ['', [Validators.required, Validators.maxLength(100)]],
      type: new UntypedFormControl('producto'),
      articleTypeId: new UntypedFormControl(2),
      barCode: new UntypedFormControl('', [BarcodeValidator.validate(['EAN13', 'EAN8', 'UPCA', 'CODE128'])]),
      measurementUnitId: ['', Validators.required],
      warehouseId: new UntypedFormControl(1),
      stock: new UntypedFormControl(1),
      stockminimo: new UntypedFormControl(0),
      stockmaximo: new UntypedFormControl(0),
      taxes: new UntypedFormControl(''),
      salePriceWithoutIva: new UntypedFormControl(0),
      salePrice: new UntypedFormControl(0),
      purchasePrice: new UntypedFormControl(0),
      purchasePriceWithoutIva: new UntypedFormControl(0),
      // Nuevos campos para calculadora de rentabilidad
      margenGanancia: new UntypedFormControl(0),
      description: new UntypedFormControl('', Validators.maxLength(200)),
      ivaRateId: ['', Validators.required],
      currencyId: ['', Validators.required],
      ivaPosition: new UntypedFormControl('gravado'),
      categoryId: ['', [Validators.required, DetalleProductoComponent.requiredSelect, DetalleProductoComponent.numericRequired]],
      brandId: ['', [Validators.required, DetalleProductoComponent.requiredSelect, DetalleProductoComponent.numericRequired]],
      sku: new UntypedFormControl(''),
      tag: new UntypedFormControl(''),
      seodescription: new UntypedFormControl(''),
      variant: new UntypedFormControl(0),
      public: new UntypedFormControl(false),
      isComposite: new UntypedFormControl(0),
      images: new UntypedFormControl(''),
    });
    this.form.controls.code.disable();
    if (!this.idProducto) {
      this.textoBtn = 'Crear';
      this.producto = new Product();
      this.editNombre = true;
      this.form.controls.variant.disable();
    } else {
      this.textoBtn = 'Actualizar';
    }

    // Inicializar el formulario para componentes
    this.componentesForm = this.fb.group({
      componentVariantId: [null, Validators.required],
      quantity: [1, [Validators.required, Validators.min(1)]]
    });
  }

  ngOnInit(): void {
    this.getParametros();
    this.cargarInformacionEmpresa();
    // Si es un artículo nuevo, activamos la edición del nombre
    if (!this.idProducto) {
      this.editNombre = true;
      // Establecemos valores por defecto para nuevos artículos
      this.establecerValoresPorDefecto();
      // Usamos setTimeout para asegurarnos que el DOM esté listo
      setTimeout(() => {
        this.nameInput?.nativeElement?.focus();
        // Vigilar el campo de nombre para aplicar validación visual
        this.form.get('name').valueChanges.subscribe(value => {
          this.validateNameField();
        });
      });
    }
    if (this.idProducto) {
      this.loadConversionUnits();
      // Cargar variantes disponibles para productos existentes
      this.cargarVariantesDisponibles();
      // Cargar impuestos del artículo desde la API
      this.loadArticleTaxesFromAPI();
    }

    // Configurar los observables para los autocompletados una vez que los datos estén cargados
    // Esto se hará en el método getParametros() para asegurar que se ejecute después de cargar los datos
    
    // Configurar subscripciones para calculadora de rentabilidad
    this.configurarSubscripcionesCalculadora();
  }

  /**
   * Carga la información de la empresa para determinar el tipo de responsable
   */
  cargarInformacionEmpresa(): void {
    this.empresaService.getEmpresaConfig().subscribe(
      (empresa: Company) => {
        this.empresaInfo = empresa;
        
        // IDs de tipos de responsables según sistema:
        // 2 = IVA Responsable Inscripto (code: "1")
        // 4 = Responsable Monotributo (code: "6") ⭐
        // 9 = IVA Sujeto Exento (code: "4")
        // 11 = Monotributista Social (code: "13")
        // Verificar si es monotributista (responsibleTypeId === 4 o 11)
        this.isMonotributista = empresa.responsibleTypeId === 4 || empresa.responsibleTypeId === 11;
      },
      (error) => {
        console.error('Error al cargar información de la empresa:', error);
        // En caso de error, asumir que NO es monotributista
        this.isMonotributista = false;
      }
    );
  }

  /**
   * Obtiene la etiqueta para el campo de precio de compra según el tipo de empresa
   */
  getPrecioCompraLabel(): string {
    return this.isMonotributista ? 'Precio de Compra con IVA *' : 'Precio de Compra sin IVA *';
  }

  /**
   * Obtiene la etiqueta para el campo de precio de compra calculado según el tipo de empresa
   */
  getPrecioCompraCalculadoLabel(): string {
    return this.isMonotributista ? 'Precio de Compra sin IVA' : 'Precio de Compra con IVA';
  }

  /**
   * Configura las subscripciones para el cálculo automático de precios
   */
  configurarSubscripcionesCalculadora(): void {
    // Cálculo bidireccional de precios de compra
    this.form.get('purchasePriceWithoutIva')?.valueChanges.subscribe(() => {
      if (!this.calculatingPurchaseBackward && !this.loadingProductData) {
        setTimeout(() => this.calcularPrecioCompraConIvaDesdeBase(), 0);
      }
      // También recalcular precios de venta
      if (!this.calculatingBackward && !this.loadingProductData) {
        setTimeout(() => this.calcularPreciosHaciaAdelante(), 0);
      }
    });

    this.form.get('purchasePrice')?.valueChanges.subscribe(() => {
      if (!this.calculatingPurchaseForward && !this.loadingProductData) {
        setTimeout(() => this.calcularPrecioCompraSinIvaDesdeTotal(), 0);
      }
      // También recalcular precios de venta después del cálculo de compra
      if (!this.calculatingBackward && !this.loadingProductData) {
        setTimeout(() => this.calcularPreciosHaciaAdelante(), 100); // Delay mayor para asegurar que termine el cálculo de compra
      }
    });

    this.form.get('margenGanancia')?.valueChanges.subscribe((value) => {
      if (!this.calculatingBackward && !this.loadingProductData) {
        setTimeout(() => this.calcularPreciosHaciaAdelante(), 0);
      }
    });

    // También recalcular cuando cambia el IVA (afecta los cálculos de compra y venta)
    this.form.get('ivaRateId')?.valueChanges.subscribe(() => {
      if (!this.calculatingPurchaseBackward && !this.calculatingPurchaseForward && !this.loadingProductData) {
        setTimeout(() => this.calcularPrecioCompraConIvaDesdeBase(), 0);
      }
      if (!this.calculatingBackward && !this.loadingProductData) {
        setTimeout(() => this.calcularPreciosHaciaAdelante(), 50);
      }
    });

    // Flujo 2: Calcular hacia atrás cuando cambia el PVP
    this.form.get('salePrice')?.valueChanges.subscribe(() => {
      if (!this.calculatingForward && !this.loadingProductData) {
        setTimeout(() => this.calcularMargenDesdePrecios(), 0);
      }
    });
  }

  // Método para validar el campo de nombre y poner foco si está vacío
  validateNameField() {
    const nameControl = this.form.get('name');
    if (!nameControl.value || nameControl.value.trim() === '') {
      nameControl.markAsTouched();
      nameControl.setErrors({ 'required': true });
      this.nameInput?.nativeElement?.focus();
      return false;
    }
    return true;
  }

  // Método para establecer valores predeterminados al crear un producto nuevo
  establecerValoresPorDefecto() {
    // Ya no generamos código de barras automáticamente
    // El usuario debe usar el botón "Generar código barras"

    // Establecemos valores predeterminados en el formulario
    this.form.patchValue({
      type: 'producto',
      ivaPosition: 'gravado',
      public: true, // Por defecto es público
      stock: 1,
      stockminimo: 1, // Stock mínimo por defecto
      stockmaximo: 100, // Stock máximo por defecto
      variant: 0,
      isComposite: 0,
      barCode: '' // Inicializar con cadena vacía
    });
  }

  // Método para establecer valores por defecto específicos desde los parámetros
  establecerValoresPorDefectoParametros() {
    // Establecer Unidad de Medida por código '07' (UNIDAD)
    const medidaPorDefecto = this.medidas.find(medida => medida.code === '07');
    if (medidaPorDefecto) {
      this.form.controls.measurementUnitId.setValue(medidaPorDefecto.id);
    }

    // Establecer Tipo de Artículo por nombre 'comercializable'
    const tipoArticuloPorDefecto = this.tiposarticulos.find(tipo =>
      tipo.name.toLowerCase() === 'comercializable'
    );
    if (tipoArticuloPorDefecto) {
      this.form.controls.articleTypeId.setValue(tipoArticuloPorDefecto.id);
    }

    // Establecer Alícuota IVA por código '5' (21%)
    const ivaPorDefecto = this.typeivas.find(iva => iva.code === '5');
    if (ivaPorDefecto) {
      this.form.controls.ivaRateId.setValue(ivaPorDefecto.id);
    }

    // Establecer Moneda por código 'PES' (PESOS)
    const monedaPorDefecto = this.monedas.find(moneda => moneda.code === 'PES');
    if (monedaPorDefecto) {
      this.form.controls.currencyId.setValue(monedaPorDefecto.id);
    }

    // NO establecer marca ni rubro por defecto para forzar la selección
    // Los campos quedarán vacíos y el usuario deberá seleccionar
    this.form.controls.brandId.setValue('');
    this.form.controls.categoryId.setValue('');
  }

  setVariante(e) {
    if (e.value) {
      this.verVariante = true;
    } else {
      this.verVariante = false;
    }
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  imgsRecover() {
    this.list = [...this.listImgCopy];
    this.isImgsToRecoverActive = false;
    this.getArrayImgLength();
  }

  openFileBrowser() {
    this.fileInput.nativeElement.click();
  }

  getArticulo() {
    this.loadingProductData = true; // Activar flag para evitar cálculos durante carga
    this.productoService.getArticulo(this.idProducto).subscribe(data => {
      this.producto = data;
      if (this.producto.variant) {
        this.verVariante = true;
        this.getVariantesByProducto();
      }

      if (!this.producto.variant) {
        this.getArticleWithoutVariantsId();
      }

      if (!this.producto.images) {
        this.producto.images = [];
      } else {
        this.list = this.producto.images;
        this.listImgCopy = [...this.list];
        this.listSinModificar = [...this.list];
      }
      // para calcular el array de imagenes de productos
      this.getArrayImgLength();
      // variantes
      this.variantes = [];
      this.dataSource.data = [];
      this.variantes = this.producto.variants ? this.producto.variants : [];
      if (this.variantes.length > 1) {
        this.dataSource.data = this.variantes;
        this.verVariante = true;
      }
      this.form.controls.code.disable();
      const stock = this.producto.stock;
      
      // Parchar valores del producto asegurando conversión correcta de precios con redondeo a 2 decimales
      this.form.patchValue({
        ...this.producto,
        salePriceWithoutIva: Math.round(parseFloat(this.producto.salePriceWithoutIva?.toString() || '0') * 100) / 100,
        salePrice: Math.round(parseFloat(this.producto.salePrice?.toString() || '0') * 100) / 100,
        purchasePriceWithoutIva: Math.round(parseFloat(this.producto.purchasePriceWithoutIva?.toString() || '0') * 100) / 100,
        purchasePrice: Math.round(parseFloat(this.producto.purchasePrice?.toString() || '0') * 100) / 100
      });
      
      // Configurar el formulario según el tipo de artículo (producto o servicio)
      this.cambiotype(this.producto.type);
      
      // Establecer el margen de ganancia si existe en los datos del backend
      if ((this.producto as any).margenGanancia !== undefined) {
        this.form.get('margenGanancia')?.setValue(Math.round(parseFloat((this.producto as any).margenGanancia?.toString() || '0') * 100) / 100);
      }

      // Convertir el campo public de número a boolean para el toggle
      if (this.producto.public !== undefined && this.producto.public !== null) {
        const publicValue = this.producto.public === 1;
        this.form.get('public')?.setValue(publicValue, { emitEvent: false });
      } else {
        // Valor por defecto para productos nuevos o sin valor definido
        this.form.get('public')?.setValue(false, { emitEvent: false });
      }

      // Deshabilitar el campo de stock cuando se edita un producto existente
      this.form.controls.stock.disable();

      if (this.producto.isComposite) {
        this.loadComponentesProducto();
      }

      // Cargar impuestos del producto si existen
      if (this.producto.taxes) {
        this.loadProductTaxes(this.producto.taxes);
      }

      // Configurar el autocompletado después de cargar los datos del producto
      this._configurarAutocompletado();

      // Desactivar flag después de cargar completamente los datos
      setTimeout(() => {
        this.loadingProductData = false;
      }, 100);

    });
  }

  getParametros() {
    this.parametroServicio.getParametrosArticulos().subscribe(
      data => {
        this.monedas = data.monedas;
        this.medidas = data.umedidas;
        this.typeivas = data.alicuotasiva;
        this.marcas = data.marcas;
        this.rubros = data.rubros;
        this.tiposarticulos = data.tiposarticulos;
        this.almacenes = data.almacenes;
        const code = data.nuevoCodigo;

        // Los impuestos se gestionan ahora a través del diálogo modal
        this.form.controls.code.setValue(code, {
          onlySelf: true,
        });
        this.form.controls.code.disable();
        // Deshabilitar el campo warehouseId para que esté siempre en 1
        this.form.get('warehouseId').disable();
        // Si es un producto nuevo, establecer valores por defecto
        if (!this.idProducto) {
          this.establecerValoresPorDefectoParametros();
        }

        if (this.idProducto) {
          this.getArticulo();
        }
        this.getArrayImgLength();

        // Configurar el autocompletado después de tener todos los datos disponibles
        setTimeout(() => {
          this._configurarAutocompletado();
        }, 100);
      },
      err => {
        console.error('Error al obtener parámetros:', err);
        this.openSnackBar('Error al cargar datos de configuración', 'Error');
      }
    );
  }

  openDialogVariantes() {
    if (this.producto.id) {
      const dialogRef = this.dialog.open(VariantesArticuloComponent, {
        minWidth: '40%',
        minHeight: '400',
        disableClose: true,
        data: {
          modoEdicion: true,
          idArticulo: this.producto.id,
          measurementUnitId: this.producto.measurementUnitId,
        },
      });
      dialogRef.beforeClosed().subscribe(data => {
        if (data) {
          this.getVariantesByProducto();
        }
      });
    } else {
      this.openSnackBar('Para cargar las variandes debe guardar el producto', 'Atención');
    }
  }

  getVariantesByProducto() {
    this.dataSource.data = [];
    this.variantes = [];
    this.productoService.getVariantesPorArticulo(this.idProducto).subscribe(
      res => {
        this.variantes = res;
        this.dataSource.data = res;
      },
      err => {
        console.log(err);
        this.openSnackBar(`Ocurrió un error al obtener variantes`, 'Error');
      }
    );
  }

  getArticleWithoutVariantsId() {
    this.productoService.getArticleWithoutVariantId(this.idProducto).subscribe(
      res => {
        this.idVariant = res?.id || null;
        if (res?.id) {
          this.getArticleWithoutVariantsStock(res.id);
        }
      },
      err => {
        console.log(err);
        this.openSnackBar(`Ocurrió un error al obtener el ID de la variante`, 'Error');
      }
    );
  }

  getArticleWithoutVariantsStock(idVariant: number) {
    this.productoService.getStockByVariantId(idVariant).subscribe(
      res => {
        this.form.controls.stock.setValue(res.quantity);
        this.form.controls.stockminimo.setValue(res.stockMin);
        this.form.controls.stockmaximo.setValue(res.stockMax);
      },
      err => {
        console.log(err);
        this.openSnackBar(`Ocurrió un error al obtener los stocks del producto`, 'Error');
      }
    );
  }

  editVariante(variante: Variant) {
    const dialogRef = this.dialog.open(VariantesArticuloComponent, {
      minWidth: '40%',
      minHeight: '400',
      disableClose: true,
      data: {
        idArticulo: this.producto.id,
        variante,
        measurementUnitId: this.producto.measurementUnitId,
      },
    });
    dialogRef.beforeClosed().subscribe(data => {
      if (data) {
        this.getVariantesByProducto();
      }
    });
  }

  deleteVariante(idVariante: number) {
    Swal.fire({
      title: 'Advertencia',
      text: '¿Seguro que desea eliminar la variante?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si',
    }).then(result => {
      if (result.value) {
        this.productoService.deleteVariante(idVariante).subscribe(
          res => {
            this.openSnackBar(`Variante eliminada correctamente`, 'Información');
            this.getVariantesByProducto();
          },
          err => {
            console.log(err);
            this.openSnackBar(`Ocurrió un error al eliminar la variante`, 'Error');
          }
        );
      }
    });
  }
  // Generamos un nuevo código de barras aleatorio
  nuevocodeBarras() {
    // Mostrar un indicador de carga en el botón
    const barCodeInput = document.querySelector('input[formControlName="barCode"]') as HTMLInputElement;
    const barCodeButton = document.querySelector('.barcode-button') as HTMLButtonElement;
    const barcodeContainer = document.querySelector('.barcode-container') as HTMLElement;

    if (barCodeButton) {
      // Cambiar el texto del botón mientras se carga
      barCodeButton.innerHTML = '<mat-icon>autorenew</mat-icon> Generando...';
      barCodeButton.classList.add('loading');
      barCodeButton.disabled = true;
    }

    if (barcodeContainer) {
      barcodeContainer.classList.add('loading-state');
    }

    this.productoService.getNuevocodeBarrasArticulos().subscribe(
      data => {
        this.form.controls.barCode.setValue(data.barCode, {
          onlySelf: true,
        });

        // Resetear validación visual cuando se genera un nuevo código
        this.barcodeHasError = false;
        this.barcodeErrorMessage = '';

        // Agregar un efecto visual temporal al campo
        if (barCodeInput) {
          barCodeInput.style.backgroundColor = '#e8f5e9';
          barCodeInput.style.transition = 'background-color 1s';

          // Agregar clase de éxito temporalmente
          barCodeInput.classList.add('success-highlight');

          // Restaurar el color de fondo después de un tiempo
          setTimeout(() => {
            barCodeInput.style.backgroundColor = '';
            barCodeInput.classList.remove('success-highlight');
          }, 2000);
        }

        // Restaurar el botón
        if (barCodeButton) {
          barCodeButton.innerHTML = '<mat-icon>qr_code_scanner</mat-icon> Generar';
          barCodeButton.classList.remove('loading');
          barCodeButton.disabled = false;
        }

        if (barcodeContainer) {
          barcodeContainer.classList.remove('loading-state');
          barcodeContainer.classList.add('success-state');

          // Eliminar la clase después de un tiempo
          setTimeout(() => {
            barcodeContainer.classList.remove('success-state');
          }, 2000);
        }
      },
      err => {
        // Restaurar el botón en caso de error
        if (barCodeButton) {
          barCodeButton.innerHTML = '<mat-icon>qr_code_scanner</mat-icon> Generar';
          barCodeButton.classList.remove('loading');
          barCodeButton.disabled = false;
        }

        if (barcodeContainer) {
          barcodeContainer.classList.remove('loading-state');
          barcodeContainer.classList.add('error-state');

          // Eliminar la clase después de un tiempo
          setTimeout(() => {
            barcodeContainer.classList.remove('error-state');
          }, 2000);
        }

        this.openSnackBar(`Ocurrió un error al obtener código de barras`, 'Error');
      }
    );
  }

  /**
   * Obtener información detallada sobre el código de barras actual
   */
  getBarcodeInfo() {
    const barcodeValue = this.form.get('barCode')?.value;
    if (!barcodeValue) {
      return null;
    }
    return BarcodeValidator.getBarcodeInfo(barcodeValue);
  }

  /**
   * Verificar si el código de barras es válido
   */
  isBarcodeValid(): boolean {
    const barcodeControl = this.form.get('barCode');
    return barcodeControl ? barcodeControl.valid : false;
  }

  /**
   * Obtener mensaje de error del código de barras
   */
  getBarcodeErrorMessage(): string {
    const barcodeControl = this.form.get('barCode');
    if (barcodeControl?.errors?.['invalidBarcode']) {
      return barcodeControl.errors['invalidBarcode'].message;
    }
    return '';
  }

  /**
   * Limpiar código de barras
   */
  clearBarcode() {
    this.form.get('barCode')?.setValue('');
    this.form.get('barCode')?.markAsUntouched();
    this.barcodeHasError = false;
    this.barcodeErrorMessage = '';
  }

  /**
   * Validar código de barras cuando pierde el foco
   */
  validateBarcodeOnBlur() {
    const barcodeControl = this.form.get('barCode');
    const value = barcodeControl?.value?.trim();
    
    if (value && value !== '') {
      barcodeControl?.markAsTouched();
      barcodeControl?.markAsDirty();
      barcodeControl?.updateValueAndValidity();
      
      const isInvalid = barcodeControl?.invalid;
      
      if (isInvalid && barcodeControl?.errors) {
        this.barcodeHasError = true;
        
        const errorObj = barcodeControl.errors['invalidBarcode'];
        if (errorObj && errorObj.message) {
          this.barcodeErrorMessage = errorObj.message;
        } else {
          this.barcodeErrorMessage = 'Código de barras inválido';
        }
      } else {
        this.barcodeHasError = false;
        this.barcodeErrorMessage = '';
      }
    } else {
      this.barcodeHasError = false;
      this.barcodeErrorMessage = '';
    }
  }

  /**
   * Limpiar error cuando el campo recibe foco
   */
  clearBarcodeError() {
    this.barcodeHasError = false;
    this.barcodeErrorMessage = '';
  }

  cambiotype(type) {
    if (type == 'producto') {
      this.verStock = true;
      this.form.controls.barCode.enable();
      // Restaurar validaciones del código de barras para productos
      this.form.controls.barCode.setValidators([BarcodeValidator.validate(['EAN13', 'EAN8', 'UPCA', 'CODE128'])]);
      this.form.controls.barCode.updateValueAndValidity();
      
      // Para productos: marca y rubro son obligatorios
      this.form.controls.brandId.setValidators([Validators.required, DetalleProductoComponent.requiredSelect, DetalleProductoComponent.numericRequired]);
      this.form.controls.categoryId.setValidators([Validators.required, DetalleProductoComponent.requiredSelect, DetalleProductoComponent.numericRequired]);
      this.form.controls.brandId.updateValueAndValidity();
      this.form.controls.categoryId.updateValueAndValidity();
      
      // Encontrar y establecer unidad de medida para productos (código '07' - UNIDAD)
      let medida = this.medidas.find(x => x.code == '07');
      if (medida) {
        this.form.controls.measurementUnitId.setValue(medida.id, {
          onlySelf: true,
        });
      }
    } else {
      // Para servicios
      this.verStock = false;
      this.form.controls.barCode.disable();
      // Limpiar validaciones del código de barras para servicios
      this.form.controls.barCode.clearValidators();
      this.form.controls.barCode.setValue('');
      this.form.controls.barCode.updateValueAndValidity();
      // Limpiar errores de código de barras
      this.barcodeHasError = false;
      this.barcodeErrorMessage = '';
      
      // Para servicios: marca y rubro son opcionales (sin validadores obligatorios)
      this.form.controls.brandId.clearValidators();
      this.form.controls.categoryId.clearValidators();
      this.form.controls.brandId.updateValueAndValidity();
      this.form.controls.categoryId.updateValueAndValidity();
      
      // Encontrar y establecer unidad de medida para servicios (código '98' - SERVICIOS)
      let medida = this.medidas.find(x => x.code == '98');
      if (medida) {
        this.form.controls.measurementUnitId.setValue(medida.id, {
          onlySelf: true,
        });
      }
      
      // Para servicios, limpiar campos relacionados con stock que no aplican
      this.form.controls.stock.setValue(0);
      this.form.controls.stockminimo.setValue(0);
      this.form.controls.stockmaximo.setValue(0);
      this.form.controls.variant.setValue(0);
      this.form.controls.isComposite.setValue(0);
    }
    
    // Forzar revalidación del formulario completo después del cambio
    this.form.updateValueAndValidity();
  }

  editarcode() {
    if (this.form.controls.code.disabled) {
      this.form.controls.code.enable();
    } else {
      this.form.controls.code.disable();
    }
  }

  // Método para alternar el estado de edición del campo 'code'
  toggleEditCode(): void {
    this.isEditingCode = !this.isEditingCode;
    this.form.controls.code[`${this.isEditingCode ? 'enable' : 'disable'}`]();
  }

  calcularIvaVenta() {
    const precio = this.form.controls.salePriceWithoutIva.value;
    
    // Si el campo está vacío, limpiar también el precio con IVA
    if (precio === 0 || precio === null || precio === '') {
      this.form.controls.salePrice.setValue('', {
        onlySelf: true,
      });
      return;
    }
    
    const precioSinIva = this.calcularPrecioSinIva(precio);
    // El redondeo ya se aplica en calcularPrecioSinIva()
    this.form.controls.salePrice.setValue(precioSinIva, {
      onlySelf: true,
    });
  }

  // Método para calcular precio sin IVA cuando se ingresa el precio con IVA
  calcularPrecioSinIvaDesdeConIva() {
    const precioConIva = this.form.controls.salePrice.value;
    
    // Si el campo está vacío, limpiar también el precio sin IVA
    if (precioConIva === 0 || precioConIva === null || precioConIva === '') {
      this.form.controls.salePriceWithoutIva.setValue('', {
        onlySelf: true,
      });
      return;
    }
    
    const ivaRateId: number = Number.parseInt(this.form.controls.ivaRateId.value);
    const iva: CondicionIva = this.typeivas.find(x => x.id === ivaRateId);
    
    if (iva && iva.name.includes('%')) {
      const precioConIvaValue = Number.parseFloat(precioConIva.toString());
      const ivaValor = iva.name.replace('%', '').trim();
      const ivaPercentage = Number.parseFloat(ivaValor.toString());
      
      // Cálculo inverso: precio sin IVA = precio con IVA / (1 + IVA/100)
      const precioSinIva = precioConIvaValue / (1 + ivaPercentage / 100);
      
      this.form.controls.salePriceWithoutIva.setValue(Math.round(precioSinIva * 100) / 100, {
        onlySelf: true,
      });
    } else {
      // Si no hay IVA configurado, el precio sin IVA es igual al precio con IVA
      this.form.controls.salePriceWithoutIva.setValue(precioConIva, {
        onlySelf: true,
      });
    }
  }

  // Método para manejar blur del precio sin IVA - setea 0 si está vacío o calcula
  onBlurPrecioSinIva() {
    const precio = this.form.controls.salePriceWithoutIva.value;
    
    // Si está vacío o es null, setear en 0
    if (precio === null || precio === '' || precio === undefined) {
      this.form.controls.salePriceWithoutIva.setValue(0, {
        onlySelf: true,
      });
      this.form.controls.salePrice.setValue(0, {
        onlySelf: true,
      });
      return;
    }
    
    // Si tiene valor, calcular normalmente
    this.calcularIvaVenta();
  }

  // Método para manejar blur del precio con IVA - setea 0 si está vacío o calcula
  onBlurPrecioConIva() {
    const precioConIva = this.form.controls.salePrice.value;
    
    // Si está vacío o es null, setear en 0
    if (precioConIva === null || precioConIva === '' || precioConIva === undefined) {
      this.form.controls.salePrice.setValue(0, {
        onlySelf: true,
      });
      this.form.controls.salePriceWithoutIva.setValue(0, {
        onlySelf: true,
      });
      return;
    }
    
    // Si tiene valor, calcular normalmente
    this.calcularPrecioSinIvaDesdeConIva();
  }

  calcularPrecioSinIva(precio) {
    let precioSinIva = 0;
    const ivaRateId: number = Number.parseInt(this.form.controls.ivaRateId.value);
    const iva: CondicionIva = this.typeivas.find(x => x.id === ivaRateId);
    if (iva && iva.name.includes('%')) {
      const precioIngresado = Number.parseFloat(precio.toString());
      const ivaValor = iva.name.replace('%', '').trim();
      const convertimosIva = Number.parseFloat(ivaValor.toString());
      const precioIva = (precio * convertimosIva) / 100;
      precioSinIva = precioIngresado + precioIva;
    } else {
      precioSinIva = precio;
    }
    // Redondear a 2 decimales antes de devolver
    return Math.round(precioSinIva * 100) / 100;
  }

  // ===== MÉTODOS PARA CALCULADORA DE RENTABILIDAD =====



  /**
   * Obtiene el total de otros impuestos configurados en la pestaña de impuestos
   * Calculado sobre el precio de venta neto (sin IVA) para precisión contable
   */
  getOtrosImpuestos(): number {
    const total = this.productTaxes.reduce((total, productTax) => {
      // Calcular el impuesto basado en el precio de venta neto (sin IVA)
      const salePriceWithoutIva = Number(this.form.get('salePriceWithoutIva')?.value) || 0;
      // Convertir percentage a número (puede venir como string)
      const percentage = productTax?.percentage ? parseFloat(productTax.percentage.toString()) : 0;
      return total + (salePriceWithoutIva * percentage / 100);
    }, 0);
    // Redondear a 2 decimales
    return Math.round(total * 100) / 100;
  }

  /**
   * Obtiene el porcentaje total de otros impuestos para el método de cascada inversa
   */
  getOtrosImpuestosPorcentaje(): number {
    if (!this.productTaxes || !Array.isArray(this.productTaxes)) {
      return 0;
    }
    
    return this.productTaxes.reduce((total, productTax) => {
      // Convertir percentage a número, ya sea que venga como string o number
      const rawPercentage = productTax?.percentage;
      const percentage = rawPercentage ? parseFloat(rawPercentage.toString()) : 0;
      return total + percentage;
    }, 0);
  }

  /**
   * Calcula el monto de IVA de venta
   */
  calcularIvaVentaMonto(): number {
    const precioVentaSinIva = Number(this.form.get('salePriceWithoutIva')?.value) || 0;
    const ivaVentaId = this.form.get('ivaRateId')?.value;
    
    if (!ivaVentaId || precioVentaSinIva === 0) return 0;
    
    const ivaVenta: CondicionIva = this.typeivas.find(x => x.id == ivaVentaId);
    if (ivaVenta && ivaVenta.name.includes('%')) {
      const ivaPercentage = Number(ivaVenta.name.replace('%', '').trim());
      const ivaAmount = (precioVentaSinIva * ivaPercentage) / 100;
      // Redondear a 2 decimales
      return Math.round(ivaAmount * 100) / 100;
    }
    return 0;
  }

  /**
   * Cálculo hacia adelante: desde costo y margen hacia precio de venta (Flujo 1)
   * Implementa método de cascada inversa para precisión contable
   */
  calcularPreciosHaciaAdelante(): void {
    if (this.calculatingBackward) return; // Evitar bucle infinito
    
    this.calculatingForward = true;

    try {
      const costoBase = Number(this.form.get('purchasePriceWithoutIva')?.value) || 0;
      const margenGanancia = Number(this.form.get('margenGanancia')?.value) || 0;
      const otrosImpuestosPorcentaje = this.getOtrosImpuestosPorcentaje();
      


      if (costoBase === 0) {
        // Si no hay costo, limpiar precios
        this.form.get('salePriceWithoutIva')?.setValue(0, { onlySelf: true, emitEvent: false });
        this.form.get('salePrice')?.setValue(0, { onlySelf: true, emitEvent: false });
        return;
      }

      // CASCADA INVERSA - Fórmula 1: Precio de Venta Neto (Sin IVA)
      // precioVentaNeto = (costoBase * (1 + margenGanancia / 100)) / (1 - otrosImpuestosPorcentaje / 100)
      const costoConMargen = costoBase * (1 + margenGanancia / 100);
      const factorImpuestos = 1 - (otrosImpuestosPorcentaje / 100);
      
      // Evitar división por cero o valores negativos
      const precioVentaNeto = factorImpuestos > 0 
        ? costoConMargen / factorImpuestos
        : costoConMargen;

      // CASCADA INVERSA - Fórmula 2: Precio de Venta al Público (PVP)
      // pvpFinal = precioVentaNeto * (1 + iva / 100)
      const ivaVentaId = this.form.get('ivaRateId')?.value;
      let ivaPorcentaje = 0;
      
      if (ivaVentaId) {
        const ivaVenta: CondicionIva = this.typeivas.find(x => x.id == ivaVentaId);
        if (ivaVenta && ivaVenta.name.includes('%')) {
          ivaPorcentaje = Number(ivaVenta.name.replace('%', '').trim());
        }
      }

      const pvpFinal = precioVentaNeto * (1 + ivaPorcentaje / 100);

      // Actualizar los campos calculados con precisión de 2 decimales
      this.form.get('salePriceWithoutIva')?.setValue(
        Math.round(precioVentaNeto * 100) / 100, 
        { onlySelf: true, emitEvent: false }
      );
      this.form.get('salePrice')?.setValue(
        Math.round(pvpFinal * 100) / 100, 
        { onlySelf: true, emitEvent: false }
      );

    } finally {
      this.calculatingForward = false;
    }
  }

  /**
   * Cálculo hacia atrás: desde precio de venta hacia margen (Flujo 2)
   * Implementa método de cascada inversa para recálculo preciso del margen
   */
  calcularMargenDesdePrecios(): void {
    if (this.calculatingForward) return; // Evitar bucle infinito
    
    this.calculatingBackward = true;

    try {
      const pvpFinal = Number(this.form.get('salePrice')?.value) || 0;
      const costoBase = Number(this.form.get('purchasePriceWithoutIva')?.value) || 0;
      const otrosImpuestosPorcentaje = this.getOtrosImpuestosPorcentaje();

      if (pvpFinal === 0) {
        // Si no hay PVP, limpiar campos calculados
        this.form.get('salePriceWithoutIva')?.setValue(0, { onlySelf: true, emitEvent: false });
        this.form.get('margenGanancia')?.setValue(0, { onlySelf: true, emitEvent: false });
        return;
      }

      if (costoBase === 0) {
        // Si no hay costo base, solo calcular el precio sin IVA desde el PVP
        // pero no podemos calcular margen sin costo base
        const ivaVentaId = this.form.get('ivaRateId')?.value;
        let ivaPorcentaje = 0;
        
        if (ivaVentaId) {
          const ivaVenta: CondicionIva = this.typeivas.find(x => x.id == ivaVentaId);
          if (ivaVenta && ivaVenta.name.includes('%')) {
            ivaPorcentaje = Number(ivaVenta.name.replace('%', '').trim());
          }
        }

        const nuevoPrecioVentaNeto = pvpFinal / (1 + ivaPorcentaje / 100);
        
        // Actualizar solo precio sin IVA, dejar margen en 0
        this.form.get('salePriceWithoutIva')?.setValue(
          Math.round(nuevoPrecioVentaNeto * 100) / 100, 
          { onlySelf: true, emitEvent: false }
        );
        
        return;
      }

      // CASCADA INVERSA HACIA ATRÁS - Paso 1: Obtener precio de venta neto desde PVP
      // nuevoPrecioVentaNeto = pvpFinal / (1 + iva / 100)
      const ivaVentaId = this.form.get('ivaRateId')?.value;
      let ivaPorcentaje = 0;
      
      if (ivaVentaId) {
        const ivaVenta: CondicionIva = this.typeivas.find(x => x.id == ivaVentaId);
        if (ivaVenta && ivaVenta.name.includes('%')) {
          ivaPorcentaje = Number(ivaVenta.name.replace('%', '').trim());
        }
      }

      const nuevoPrecioVentaNeto = pvpFinal / (1 + ivaPorcentaje / 100);

      // CASCADA INVERSA HACIA ATRÁS - Paso 2: Calcular margen desde precio de venta neto
      // De la fórmula: precioVentaNeto = (costoBase * (1 + margenGanancia / 100)) / (1 - otrosImpuestosPorcentaje / 100)
      // Despejamos: nuevoMargenGanancia = ( ( (nuevoPrecioVentaNeto * (1 - otrosImpuestosPorcentaje / 100)) / costoBase ) - 1 ) * 100
      
      const factorImpuestos = 1 - (otrosImpuestosPorcentaje / 100);
      const costoConMargenCalculado = nuevoPrecioVentaNeto * factorImpuestos;
      const nuevoMargenGanancia = ((costoConMargenCalculado / costoBase) - 1) * 100;

      // Actualizar los campos calculados con precisión de 2 decimales
      this.form.get('salePriceWithoutIva')?.setValue(
        Math.round(nuevoPrecioVentaNeto * 100) / 100, 
        { onlySelf: true, emitEvent: false }
      );
      this.form.get('margenGanancia')?.setValue(
        Math.round(nuevoMargenGanancia * 100) / 100, 
        { onlySelf: true, emitEvent: false }
      );

    } finally {
      this.calculatingBackward = false;
    }
  }

  /**
   * Calcula precio de compra con IVA desde precio sin IVA (Flujo hacia adelante de compra)
   */
  calcularPrecioCompraConIvaDesdeBase(): void {
    if (this.calculatingPurchaseBackward) return; // Evitar bucle infinito
    
    this.calculatingPurchaseForward = true;

    try {
      const purchasePriceWithoutIva = Number(this.form.get('purchasePriceWithoutIva')?.value) || 0;
      const ivaRateId = this.form.get('ivaRateId')?.value;
      
      if (purchasePriceWithoutIva === 0) {
        this.form.get('purchasePrice')?.setValue(0, { onlySelf: true, emitEvent: false });
        return;
      }

      let precioConIva = purchasePriceWithoutIva;

      if (ivaRateId) {
        const ivaRate: CondicionIva = this.typeivas.find(x => x.id == ivaRateId);
        if (ivaRate && ivaRate.name.includes('%')) {
          const ivaPercentage = Number(ivaRate.name.replace('%', '').trim());
          const ivaAmount = (purchasePriceWithoutIva * ivaPercentage) / 100;
          precioConIva = purchasePriceWithoutIva + ivaAmount;
        }
      }

      this.form.get('purchasePrice')?.setValue(Math.round(precioConIva * 100) / 100, { onlySelf: true, emitEvent: false });

    } finally {
      this.calculatingPurchaseForward = false;
    }
  }

  /**
   * Calcula precio de compra sin IVA desde precio con IVA (Flujo hacia atrás de compra)
   */
  calcularPrecioCompraSinIvaDesdeTotal(): void {
    if (this.calculatingPurchaseForward) return; // Evitar bucle infinito
    
    this.calculatingPurchaseBackward = true;

    try {
      const purchasePriceWithIva = Number(this.form.get('purchasePrice')?.value) || 0;
      const ivaRateId = this.form.get('ivaRateId')?.value;
      
      if (purchasePriceWithIva === 0) {
        this.form.get('purchasePriceWithoutIva')?.setValue(0, { onlySelf: true, emitEvent: false });
        return;
      }

      let precioSinIva = purchasePriceWithIva;

      if (ivaRateId) {
        const ivaRate: CondicionIva = this.typeivas.find(x => x.id == ivaRateId);
        if (ivaRate && ivaRate.name.includes('%')) {
          const ivaPercentage = Number(ivaRate.name.replace('%', '').trim());
          // Cálculo inverso: precio sin IVA = precio con IVA / (1 + IVA/100)
          precioSinIva = purchasePriceWithIva / (1 + ivaPercentage / 100);
        }
      }

      this.form.get('purchasePriceWithoutIva')?.setValue(Math.round(precioSinIva * 100) / 100, { onlySelf: true, emitEvent: false });

    } finally {
      this.calculatingPurchaseBackward = false;
    }
  }

  // ===== FIN MÉTODOS CALCULADORA DE RENTABILIDAD =====

  getArrayImgLength() {
    let longitud = this.list.length;

    this.listNoImg = Array.from({ length: 5 - longitud }, (_, index) => index + 1);
  }

  onFileChange(file) {
    // file[0].name para usar para cuando se haga el post
    //file[0].url para la vista previa
    const f = file[0];

    if (f && f.file.type.indexOf('image') === -1) {
      Swal.fire({
        title: 'Error!',
        text: 'Se admiten archivos con extensión del type .jpg/.jpeg/.png',
        icon: 'warning',
        confirmButtonText: 'Salir',
      });

      return;
    }

    file[0].main_image = false;

    this.list.push(file[0]);
    this.listImgCopy = [...this.list];
    this.getArrayImgLength();
  }

  borrarImg({ id }) {
    //TODO implementar quitar img por id, las img deberían tener un id y un string con la url
    this.isImgsToRecoverActive = true;
    let indexToDelete = id.split('_')[1];
    
    document.getElementById(id).classList.add('slit-out-diagonal-1');
    setTimeout(() => {
      // Eliminar de la lista principal
      this.list.splice(indexToDelete, 1);
      
      // También eliminar de listSinModificar para productos existentes
      this.listSinModificar.splice(indexToDelete, 1);
      
      // Actualizar listImgCopy para mantener consistencia
      this.listImgCopy = [...this.list];
      
      // Recalcular array de imágenes faltantes
      this.getArrayImgLength();
      
      // Ajustar selectedIndexMainImage si es necesario
      if (this.selectedIndexMainImage >= this.list.length && this.list.length > 0) {
        this.selectedIndexMainImage = 0;
        // Marcar la primera imagen como principal si había una imagen principal eliminada
        if (this.list.length > 0) {
          this.cambiarMainImage(0);
        }
      } else if (this.list.length === 0) {
        this.selectedIndexMainImage = 0;
      }
    }, 800);
  }

  guardarImagenes(): Promise<any[]> {
    //TODO: replantear como guardar img cuando ya hay img guardadas
    return new Promise(async (resolve, reject) => {
      let listado = [];
      if (this.list.length === 0) {
        resolve([]);
        return;
      }

      // Separar imágenes nuevas (con file) de imágenes existentes (sin file)
      const imagenesNuevas = this.list.filter(img => img['file']);
      const imagenesExistentes = this.list.filter(img => !img['file'] && img['url']);

      // Procesar imágenes nuevas
      for (let index = 0; index < imagenesNuevas.length; index++) {
        try {
          const res = await this.archivoService.subirImagen(imagenesNuevas[index]['file']);

          // Mapear correctamente la respuesta del servicio
          let imgObj = {
            name: res.data?.originalname || res['originalName'], // Soporte para ambas estructuras
            uniqueFileName: res.data?.filename || res['uniqueFileName'],
            size: imagenesNuevas[index]['file'].size,
            url: res.data?.url || res['url'],
            contentType: res.data?.mimetype || res['contentType'],
            main_image: this.selectedIndexMainImage === this.list.indexOf(imagenesNuevas[index]) ? true : false,
          };

          listado.push(imgObj);
        } catch (error) {
          console.error('Error al subir imagen:', error);
          Swal.fire({
            title: 'Error!',
            text: 'Hubo un inconveniente al subir la imagen del producto',
            icon: 'error',
            confirmButtonText: 'Salir',
          });
          reject(error);
          return;
        }
      }

      // Agregar imágenes existentes (ya subidas previamente)
      imagenesExistentes.forEach((img, index) => {
        let imgObj = {
          name: img.name || img.originalName,
          uniqueFileName: img.uniqueFileName || img.filename,
          size: img.size,
          url: img.url,
          contentType: img.contentType || img.mimetype,
          main_image: this.selectedIndexMainImage === this.list.indexOf(img) ? true : false,
        };
        listado.push(imgObj);
      });

      // Asegurar que hay una imagen principal si hay imágenes
      if (listado.length > 0) {
        const hasMainImage = listado.some(img => img.main_image);
        if (!hasMainImage) {
          listado[0].main_image = true;
        }
      }

      resolve(listado);
    });
  }

  async checkImagenesCargadas() {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title: 'Advertencia',
        text: '¿Seguro que desea guardar un producto sin imágenes?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si',
      }).then(result => {
        console.log({ result });
        if (result.value) {
          this.list = [];
          resolve(true);
        } else {
          reject(false);
        }
      });
    });
  }

  async guardarProducto() {
    try {
      // Marcar todos los campos como tocados para mostrar errores de validación
      this.form.markAllAsTouched();

      // Verificar si el formulario es válido
      if (this.form.invalid) {
        // Verificar específicamente marca y rubro primero
        if (this.form.get('brandId')?.invalid) {
          this.openSnackBar('Debe seleccionar una marca', 'Error');
          return;
        }

        if (this.form.get('categoryId')?.invalid) {
          this.openSnackBar('Debe seleccionar un rubro', 'Error');
          return;
        }

        // Verificar específicamente el código de barras
        const barcodeControl = this.form.get('barCode');
        if (barcodeControl?.value && barcodeControl.invalid) {
          const errorMessage = this.getBarcodeErrorMessage();
          this.openSnackBar(errorMessage || 'El código de barras no es válido', 'Error');
          return;
        }

        // Encontrar el primer campo inválido y mostrarlo
        let firstInvalidField = '';
        Object.keys(this.form.controls).forEach(key => {
          if (this.form.get(key)?.invalid && !firstInvalidField) {
            switch (key) {
              case 'name':
                firstInvalidField = 'Nombre';
                break;
              case 'measurementUnitId':
                firstInvalidField = 'Unidad de medida';
                break;
              case 'ivaRateId':
                firstInvalidField = 'IVA';
                break;
              case 'currencyId':
                firstInvalidField = 'Moneda';
                break;
              case 'code':
                firstInvalidField = 'Código';
                break;
              case 'barCode':
                firstInvalidField = 'Código de barras';
                break;
              default:
                firstInvalidField = 'Un campo requerido';
            }
          }
        });

        this.openSnackBar(`${firstInvalidField} es requerido`, 'Error');
        return;
      }

      // Validar componentes si es producto compuesto
      if (this.form.controls['isComposite'].value && this.producto.id) {
        this.validarComponentesSuficientes();
        if (this.errorComponentes) {
          this.openSnackBar(this.mensajeErrorComponentes, 'Error');
          return;
        }
      }

      this.isLoading = true;
      //if (this.list.length === 0) await this.checkImagenesCargadas();

      // Aplicar trim() a los campos de texto antes de guardar
      const codeValue = String(this.form.controls.code.value).trim();
      const barCodeValue = this.form.controls.barCode.value ? String(this.form.controls.barCode.value).trim() : '';
      const descriptionValue = this.form.controls.description.value ? String(this.form.controls.description.value).trim() : '';
      const nameValue = this.form.controls.name.value ? String(this.form.controls.name.value).trim() : '';
      const skuValue = this.form.controls.sku.value ? String(this.form.controls.sku.value).trim() : (barCodeValue || '');

      // Crear un objeto limpio con solo las propiedades necesarias para evitar enviar propiedades no permitidas como replacementCost
      const productoParaActualizar: Product = {
        id: this.producto.id,
        code: codeValue,
        barCode: barCodeValue,
        description: descriptionValue,
        name: nameValue,
        type: this.form.controls.type.value,
        articleTypeId: this.form.controls.articleTypeId.value,
        measurementUnitId: Number(this.form.controls.measurementUnitId.value),
        secondaryMeasurementUnitId: this.producto.secondaryMeasurementUnitId,
        deposito: this.producto.deposito,
        stock: this.form.controls.stock.value,
        stockminimo: this.form.controls.stockminimo.value,
        stockmaximo: this.form.controls.stockmaximo.value,
        taxes: this.producto.taxes,
        salePriceWithoutIva: this.form.controls.salePriceWithoutIva.value,
        purchasePriceWithoutIva: this.form.controls.purchasePriceWithoutIva.value,
        purchasePrice: this.form.controls.purchasePrice.value,
        salePrice: this.form.controls.salePrice.value,
        margenGanancia: this.form.controls.margenGanancia.value,
        totalTax: this.producto.totalTax,
        batch: this.producto.batch,
        expirationDate: this.producto.expirationDate,
        stockactual: this.producto.stockactual,
        ivaRateId: this.form.controls.ivaRateId.value,
        ivaPosition: this.form.controls.ivaPosition.value,
        currencyId: this.form.controls.currencyId.value,
        listaprecio: this.producto.listaprecio,
        categoryId: 0, // Se asignará después
        brandId: 0, // Se asignará después
        sku: skuValue,
        variant: this.form.controls.variant.value,
        variants: this.producto.variants,
        public: this.form.controls.public.value === true ? 1 : 0,
        isComposite: this.form.controls.isComposite.value == false ? 0 : 1,
        images: [], // Se asignará después si es necesario
        user: this.authService.getUID(),
        warehouseId: 1,
        quantity: this.producto.quantity
      };

      // Validar y asignar brandId y categoryId según el tipo
      const brandIdValue = this.form.controls.brandId.value;
      const categoryIdValue = this.form.controls.categoryId.value;
      const isProducto = this.form.controls.type.value === 'producto';

      // Para productos: marca y rubro son obligatorios
      if (isProducto) {
        if (!brandIdValue || brandIdValue === '' || brandIdValue === 0) {
          this.openSnackBar('Debe seleccionar una marca', 'Error');
          return;
        }

        if (!categoryIdValue || categoryIdValue === '' || categoryIdValue === 0) {
          this.openSnackBar('Debe seleccionar un rubro', 'Error');
          return;
        }
        
        // Asignar valores para productos
        productoParaActualizar.categoryId = Number(categoryIdValue);
        productoParaActualizar.brandId = Number(brandIdValue);
      } else {
        // Para servicios: marca y rubro son opcionales
        // Si no se seleccionaron, se puede enviar un valor por defecto o null
        productoParaActualizar.categoryId = categoryIdValue ? Number(categoryIdValue) : 1; // ID por defecto para servicios
        productoParaActualizar.brandId = brandIdValue ? Number(brandIdValue) : 1; // ID por defecto para servicios
      }

      // SIEMPRE procesar imágenes para asegurar sincronización con eliminaciones
      productoParaActualizar.images = await this.guardarImagenes();

      if (this.producto.id) {
        this.productoService.modificarArticulo(productoParaActualizar).subscribe(
          data => {
            this.isLoading = false;
            // Guardar la última página visitada en localStorage
            const lastPage = localStorage.getItem('productos_last_page');
            if (lastPage !== null) {
              localStorage.setItem('productos_last_page', lastPage);
            } else if (window && window.sessionStorage) {
              // fallback: si no existe, guardar 0
              localStorage.setItem('productos_last_page', '0');
            }
            this.router.navigate(['productos']);
            this.openSnackBar(
              `Se actualizó correctamente`,
              'Información'
            );
          },
          err => {
            this.isLoading = false;
            console.log({ err });
            this.openSnackBar(`Ocurrió un error al actualizar un producto`, 'Error');
          }
        );
      } else {
        this.productoService.guardarArticulo(productoParaActualizar).subscribe(
          async data => {
            this.isLoading = false;
            const nuevoArticuloId = data.id;

            // Guardar la última página visitada en localStorage
            const lastPage = localStorage.getItem('productos_last_page');
            if (lastPage !== null) {
              localStorage.setItem('productos_last_page', lastPage);
            } else if (window && window.sessionStorage) {
              localStorage.setItem('productos_last_page', '0');
            }

            // Crear un array de promesas para guardar proveedores e impuestos
            const promisesToRun: Promise<any>[] = [];

            if (this.isNewProduct && this.tempProveedores.length > 0) {
              promisesToRun.push(this.guardarProveedoresTemporales(nuevoArticuloId));
            }

            if (this.isNewProduct && this.productTaxes.length > 0) {
              promisesToRun.push(this.guardarImpuestosTemporales(nuevoArticuloId));
            }

            // Ejecutar todas las promesas en paralelo
            try {
              await Promise.all(promisesToRun);
              this.openSnackBar('Producto y sus asociaciones guardados correctamente', 'Éxito');
            } catch (error) {
              console.error('Error al guardar asociaciones:', error);
              this.openSnackBar('Producto guardado, pero hubo un error al guardar proveedores o impuestos.', 'Advertencia');
            }

            this.router.navigate(['productos']);
          },
          err => {
            console.log({ err });
            this.isLoading = false;
            this.openSnackBar(`${err.message}`, 'Error');
          }
        );
      }
    } catch (error) {
      console.log(error);
      this.openSnackBar(`Ocurrió un error al guardar un producto`, 'Error');
      this.isLoading = false;
    }
  }

  cambiarMainImage(indexImgSelected: number) {
    this.listImgCopy.forEach((img, index) => {
      if (index === indexImgSelected) {
        this.selectedIndexMainImage = indexImgSelected;
      }
      img.main_image = index === indexImgSelected;
    });
  }

  loadConversionUnits() {
    this.productoService.getConversionUnits(this.idProducto).subscribe(
      (data: ConversionUnits[]) => {
        this.conversionUnits = data;
      },
      error => {
        console.error('Error al cargar unidades de conversión:', error);
      }
    );
  }

  openConversionUnitDialog(conversionUnit?: ConversionUnits) {
    const dialogRef = this.dialog.open(ConversionUnitsDialogComponent, {
      width: '500px',
      data: {
        title: conversionUnit
          ? 'Editar Unidad de Conversión'
          : 'Nueva Unidad de Conversión',
        units: this.medidas,
        conversionUnit,
        articleId: this.idProducto,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (conversionUnit?.id) {
          this.productoService
            .updateConversionUnit(conversionUnit.id, result)
            .subscribe(() => {
              this.loadConversionUnits();
              this._snackBar.open('Unidad de conversión actualizada', 'Cerrar', {
                duration: 3000,
              });
            });
        } else {
          this.productoService
            .createConversionUnit(this.idProducto, result)
            .subscribe(() => {
              this.loadConversionUnits();
              this._snackBar.open('Unidad de conversión creada', 'Cerrar', {
                duration: 3000,
              });
            });
        }
      }
    });
  }

  editConversionUnit(conversionUnit: ConversionUnits) {
    this.openConversionUnitDialog(conversionUnit);
  }

  deleteConversionUnit(id: number) {
    Swal.fire({
      title: '¿Está seguro de eliminar esta unidad de conversión?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
    }).then(result => {
      if (result.isConfirmed) {
        this.productoService.deleteConversionUnit(id).subscribe(
          () => {
            this.loadConversionUnits();
            this._snackBar.open('Unidad de conversión eliminada', 'Cerrar', {
              duration: 3000,
            });
          },
          error => {
            console.error('Error al eliminar la unidad de conversión:', error);
            this._snackBar.open('Error al eliminar la unidad de conversión', 'Cerrar', {
              duration: 3000,
            });
          }
        );
      }
    });
  }

  // Método para actualizar cuando cambia isComposite
  onIsCompositeChanged() {
    if (this.form.controls['isComposite'].value && this.producto.id) {
      this.loadComponentesProducto();
      this.cargarVariantesDisponibles();
    }
  }

  // Cargar componentes del producto compuesto
  loadComponentesProducto() {
    if (!this.producto || !this.producto.id) {
      return;
    }

    this.productoService.getCompositeArticleVariants(this.producto.id).subscribe(
      (data) => {
        this.componentesDataSource.data = data;
        this.validarComponentesSuficientes();
      },
      (error) => {
        console.error('Error al cargar componentes del producto compuesto:', error);
        this.openSnackBar('Error al cargar componentes del producto', 'Error');
      }
    );
  }

  // Cargar variantes disponibles para añadir como componentes
  cargarVariantesDisponibles() {
    this.productoService.getVariantesDisponibleVenta().subscribe(
      (res) => {
        this.variantesDisponibles = res;
      },
      (error) => {
        console.error('Error al cargar variantes disponibles:', error);
        this.openSnackBar('Error al cargar variantes disponibles', 'Error');
      }
    );
  }

  // Método para añadir un componente al producto compuesto
  agregarComponente() {
    if (!this.producto.id) {
      this.openSnackBar('Debe guardar el producto primero', 'Error');
      return;
    }

    const dialogRef = this.dialog.open(ComponenteDialogoComponent, {
      width: '500px',
      data: {
        titulo: 'Agregar Componente',
        variantes: this.variantesDisponibles
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const componenteNuevo = {
          compositeArticleId: this.producto.id,
          componentVariantId: result.componentVariantId,
          quantity: result.quantity
        };

        this.productoService.addCompositeArticleVariant(componenteNuevo).subscribe(
          (res) => {
            this.loadComponentesProducto();
            this.openSnackBar('Componente añadido correctamente', 'Éxito');
          },
          (error) => {
            console.error('Error al añadir componente:', error);
            this.openSnackBar('Error al añadir componente', 'Error');
          }
        );
      }
    });
  }

  // Método para actualizar la cantidad de un componente
  actualizarCantidadComponente(componente: CompositeArticleVariant, event: any) {
    const cantidad = Number(event.target.value);

    if (isNaN(cantidad) || cantidad <= 0) {
      this.openSnackBar('La cantidad debe ser un número mayor que 0', 'Error');
      event.target.value = componente.quantity;
      return;
    }

    this.productoService.updateCompositeArticleVariant(componente.id, { quantity: cantidad }).subscribe(
      () => {
        componente.quantity = cantidad;
        this.openSnackBar('Cantidad actualizada', 'Éxito');
      },
      (error) => {
        console.error('Error al actualizar cantidad:', error);
        this.openSnackBar('Error al actualizar cantidad', 'Error');
        event.target.value = componente.quantity;
      }
    );
  }

  // Método para eliminar un componente
  eliminarComponente(componente: CompositeArticleVariant) {
    Swal.fire({
      title: '¿Está seguro?',
      text: '¿Desea eliminar este componente del producto compuesto?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.productoService.deleteCompositeArticleVariant(componente.id).subscribe(
          () => {
            this.loadComponentesProducto();
            this.openSnackBar('Componente eliminado correctamente', 'Éxito');
          },
          (error) => {
            console.error('Error al eliminar componente:', error);
            this.openSnackBar('Error al eliminar componente', 'Error');
          }
        );
      }
    });
  }

  // Validar que hay al menos 2 componentes
  validarComponentesSuficientes() {
    const tieneComponentesSuficientes = this.componentesDataSource.data.length >= 2;
    this.errorComponentes = this.form.controls['isComposite'].value && !tieneComponentesSuficientes;
    this.mensajeErrorComponentes = 'Un producto compuesto debe tener al menos 2 componentes';
  }

  // Configurar filtros de autocompletado
  private _configurarAutocompletado() {
    // Verificar que los datos estén cargados antes de configurar
    if (!this.medidas || this.medidas.length === 0 ||
      !this.rubros || this.rubros.length === 0 ||
      !this.marcas || this.marcas.length === 0) {
      console.warn('Datos para autocompletado no disponibles aún');
      // Reintentar en un momento
      setTimeout(() => this._configurarAutocompletado(), 500);
      return;
    }

    // Filtrar unidades de medida
    this.medidasFiltradas = this.form.controls.measurementUnitId.valueChanges.pipe(
      startWith(''),
      map(value => {
        const nombre = typeof value === 'string' ? value : this._getNombreMedida(value);
        return this._filtrarMedidas(nombre);
      })
    );

    // Filtrar rubros
    this.rubrosFiltrados = this.form.controls.categoryId.valueChanges.pipe(
      startWith(''),
      map(value => {
        const nombre = typeof value === 'string' ? value : this._getNombreRubro(value);
        return this._filtrarRubros(nombre);
      })
    );

    // Filtrar marcas
    this.marcasFiltradas = this.form.controls.brandId.valueChanges.pipe(
      startWith(''),
      map(value => {
        const nombre = typeof value === 'string' ? value : this._getNombreMarca(value);
        return this._filtrarMarcas(nombre);
      })
    );
  }

  // Funciones de ayuda para filtrado
  private _filtrarMedidas(value: string): MeasurementUnit[] {
    const filterValue = value.toLowerCase();
    return this.medidas.filter(medida =>
      medida.name.toLowerCase().includes(filterValue));
  }

  private _filtrarRubros(value: string): Category[] {
    const filterValue = value.toLowerCase();
    return this.rubros.filter(rubro =>
      rubro.name.toLowerCase().includes(filterValue));
  }

  private _filtrarMarcas(value: string): Brand[] {
    const filterValue = value.toLowerCase();
    return this.marcas.filter(marca =>
      marca.name.toLowerCase().includes(filterValue));
  }

  // Funciones para obtener nombres de objetos
  private _getNombreMedida(value: any): string {
    if (value === null || value === undefined) return '';
    const medida = this.medidas.find(m => m.id === value);
    return medida ? medida.name : '';
  }

  private _getNombreRubro(value: any): string {
    if (value === null || value === undefined) return '';
    const rubro = this.rubros.find(r => r.id === value);
    return rubro ? rubro.name : '';
  }

  private _getNombreMarca(value: any): string {
    if (value === null || value === undefined) return '';
    const marca = this.marcas.find(m => m.id === value);
    return marca ? marca.name : '';
  }

  // Funciones para mostrar nombres en el autocomplete
  displayMedida(id: any): string {
    if (!id || typeof id !== 'number') return '';
    const medida = this.medidas.find(m => m.id === id);
    return medida ? medida.name : '';
  }

  displayRubro(id: any): string {
    if (!id || typeof id !== 'number') return '';
    const rubro = this.rubros.find(r => r.id === id);
    return rubro ? rubro.name : '';
  }

  displayMarca(id: any): string {
    if (!id || typeof id !== 'number') return '';
    const marca = this.marcas.find(m => m.id === id);
    return marca ? marca.name : '';
  }

  // Métodos para abrir diálogos de nueva marca y rubro
  abrirDialogoNuevaMarca() {
    const dialogRef = this.dialog.open(CreateMarcaComponent, {
      disableClose: true,
      autoFocus: false, // Desactivar autoFocus para controlar manualmente el focus
      width: '400px',
      data: {
        name: '',
        code: '',
        type: 'Nueva',
        existingBrands: this.marcas, // Pasar las marcas existentes para generar códigos consecutivos
      },
    });

    dialogRef.afterClosed().subscribe((data) => {
      if (!data) return;

      const { code, name } = data;
      let marca: Brand = new Brand();
      marca.code = code;
      marca.name = name;

      this.parametroServicio.guardarMarca(marca).subscribe(
        (response) => {
          this.openSnackBar('Marca creada correctamente', 'Éxito');
          // Recargar las marcas para incluir la nueva
          this.recargarMarcas(response.id);
        },
        (error) => {
          console.error('Error al crear la marca', error);
          this.openSnackBar('Error al crear la marca', 'Error');
        }
      );
    });
  }

  abrirDialogoNuevoRubro() {
    const dialogRef = this.dialog.open(CreateRubroComponent, {
      disableClose: true,
      autoFocus: false, // Desactivar autoFocus para controlar manualmente el focus
      width: '400px',
      data: {
        name: '',
        code: '',
        type: 'Nuevo',
        existingCategories: this.rubros, // Pasar los rubros existentes para generar códigos consecutivos
      },
    });

    dialogRef.afterClosed().subscribe((data) => {
      if (!data) return;

      const { code, name } = data;
      let rubro: Category = new Category();
      rubro.code = code;
      rubro.name = name;

      this.parametroServicio.guardarRubro(rubro).subscribe(
        (response) => {
          this.openSnackBar('Rubro creado correctamente', 'Éxito');
          // Recargar los rubros para incluir el nuevo
          this.recargarRubros(response.id);
        },
        (error) => {
                   console.error('Error al crear el rubro', error);
          this.openSnackBar('Error al crear el rubro', 'Error');
        }
      );
    });
  }

  // Métodos para recargar las listas después de crear nuevos registros
  private recargarMarcas(nuevaMarcaId?: number) {
    this.parametroServicio.getParametrosArticulos().subscribe(
      data => {
        this.marcas = data.marcas;

        // Si se creó una nueva marca, seleccionarla automáticamente
        if (nuevaMarcaId) {
          this.form.patchValue({ brandId: nuevaMarcaId });
        }
      },
      err => {
        console.error('Error al recargar marcas:', err);
        this.openSnackBar('Error al recargar marcas', 'Error');
      }
    );
  }

  private recargarRubros(nuevoRubroId?: number) {
    this.parametroServicio.getParametrosArticulos().subscribe(
      data => {
        this.rubros = data.rubros;

        // Si se creó un nuevo rubro, seleccionarlo automáticamente
        if (nuevoRubroId) {
          this.form.patchValue({ categoryId: nuevoRubroId });
        }
      },
      err => {
        console.error('Error al recargar rubros:', err);
        this.openSnackBar('Error al recargar rubros', 'Error');
      }
    );
  }

  // Métodos para manejar proveedores temporales en productos nuevos
  agregarProveedorTemporal(proveedor: Client) {
    // Verificar que no esté ya agregado
    const yaExiste = this.tempProveedores.find(p => p.id === proveedor.id);
    if (!yaExiste) {
      this.tempProveedores.push(proveedor);
      this.openSnackBar('Proveedor agregado temporalmente', 'Información');
    } else {
      this.openSnackBar('El proveedor ya está agregado', 'Atención');
    }
  }

  eliminarProveedorTemporal(proveedorId: number) {
    this.tempProveedores = this.tempProveedores.filter(p => p.id !== proveedorId);
    this.openSnackBar('Proveedor eliminado', 'Información');
  }

  private async guardarProveedoresTemporales(articuloId: number): Promise<void> {
    if (this.tempProveedores.length === 0) {
      return Promise.resolve();
    }

    const promesas = this.tempProveedores.map(proveedor => {
      return new Promise<void>((resolve, reject) => {
        this.articuloProveedorService.addProveedorArticulo(articuloId, proveedor.id).subscribe(
          () => {
            console.log(`Proveedor ${proveedor.companyName} asociado al artículo ${articuloId}`);
            resolve();
          },
          error => {
            console.error(`Error al asociar proveedor ${proveedor.companyName}:`, error);
            reject(error);
          }
        );
      });
    });

    try {
      await Promise.all(promesas);
      this.openSnackBar(`${this.tempProveedores.length} proveedor(es) asociado(s) correctamente`, 'Éxito');
      this.tempProveedores = []; // Limpiar la lista temporal
    } catch (error) {
      console.error('Error al guardar algunos proveedores:', error);
      this.openSnackBar('Algunos proveedores no pudieron ser asociados', 'Advertencia');
    }
  }

  /**
   * Guarda los impuestos agregados localmente a un nuevo producto después de que se crea.
   */
  private async guardarImpuestosTemporales(articuloId: number): Promise<void> {
    if (this.productTaxes.length === 0) {
      return;
    }

    const promesas = this.productTaxes.map(tax => {
      const taxData = {
        articleId: articuloId,
        taxId: tax.tax.id,
        taxPercentage: tax.percentage,
        name: tax.observations || tax.tax.desc
      };
      return this.productoService.addArticleTax(taxData).toPromise();
    });

    try {
      await Promise.all(promesas);
      // No mostramos snackbar aquí para no duplicar mensajes
    } catch (error) {
      console.error('Error al guardar los impuestos temporales:', error);
      // Propagar el error para que el llamador lo maneje
      throw new Error('No se pudieron guardar los impuestos asociados.');
    }
  }

  // Método para manejar el cambio del toggle público
  onPublicToggleChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    const isChecked = target.checked;
    
    // Actualizar el valor en el formulario
    this.form.get('public')?.setValue(isChecked, { emitEvent: false });
    
    // Llamar a la función de actualización si existe un producto
    if (this.idProducto) {
      this.updatePublicStatus();
    }
  }

  // Método para actualizar el estado público del artículo enviando el DTO completo
  updatePublicStatus(): void {
    if (!this.idProducto) {
      this.openSnackBar('Debe guardar el producto antes de cambiar el estado público', 'Advertencia');
      return;
    }

    const isPublic = this.form.get('public')?.value;
    
    // Aplicar trim() a los campos de texto
    const codeValue = String(this.form.controls.code.value).trim();
    const barCodeValue = this.form.controls.barCode.value ? String(this.form.controls.barCode.value).trim() : '';
    const descriptionValue = this.form.controls.description.value ? String(this.form.controls.description.value).trim() : '';
    const nameValue = this.form.controls.name.value ? String(this.form.controls.name.value).trim() : '';
    const skuValue = this.form.controls.sku.value ? String(this.form.controls.sku.value).trim() : (barCodeValue || '');

    // Crear el DTO completo del artículo
    const productoParaActualizar: Product = {
      id: this.producto.id,
      code: codeValue,
      barCode: barCodeValue,
      description: descriptionValue,
      name: nameValue,
      type: this.form.controls.type.value,
      articleTypeId: this.form.controls.articleTypeId.value,
      measurementUnitId: Number(this.form.controls.measurementUnitId.value),
      secondaryMeasurementUnitId: this.producto.secondaryMeasurementUnitId,
      deposito: this.producto.deposito,
      stock: this.form.controls.stock.value,
      stockminimo: this.form.controls.stockminimo.value,
      stockmaximo: this.form.controls.stockmaximo.value,
      taxes: this.producto.taxes,
      salePriceWithoutIva: this.form.controls.salePriceWithoutIva.value,
      purchasePriceWithoutIva: this.form.controls.purchasePriceWithoutIva.value,
      purchasePrice: this.form.controls.purchasePrice.value,
      salePrice: this.form.controls.salePrice.value,
      totalTax: this.producto.totalTax,
      batch: this.producto.batch,
      expirationDate: this.producto.expirationDate,
      stockactual: this.producto.stockactual,
      ivaRateId: this.form.controls.ivaRateId.value,
      ivaPosition: this.form.controls.ivaPosition.value,
      currencyId: this.form.controls.currencyId.value,
      listaprecio: this.producto.listaprecio,
      categoryId: Number(this.form.controls.categoryId.value),
      brandId: Number(this.form.controls.brandId.value),
      sku: skuValue,
      variant: this.form.controls.variant.value,
      variants: this.producto.variants,
      public: isPublic === true ? 1 : 0, // Campo actualizado
      isComposite: this.form.controls.isComposite.value == false ? 0 : 1,
      images: this.producto.images || [],
      user: this.authService.getUID(),
      warehouseId: 1,
      quantity: this.producto.quantity
    };

    this.productoService.modificarArticulo(productoParaActualizar).subscribe({
      next: (response) => {
        const mensaje = isPublic ? 'Producto marcado como público' : 'Producto marcado como no público';
        this.openSnackBar(mensaje, 'Éxito');
      },
      error: (error) => {
        console.error('Error al actualizar estado público:', error);
        this.openSnackBar('Error al actualizar el estado público del producto', 'Error');
        // Revertir el cambio en el formulario si hay error
        this.form.get('public')?.setValue(!isPublic, { emitEvent: false });
      }
    });
  }

  // ===== MÉTODOS PARA MANEJO DE IMPUESTOS (DELEGADOS AL DIÁLOGO) =====

  /**
   * Abre el diálogo para agregar un impuesto al producto
   */
  openTaxesDialog() {
    const dialogRef = this.dialog.open(ImpuestosDialogComponent, {
      width: '700px',
      maxWidth: '95vw',
      maxHeight: '80vh',
      data: {
        title: 'Agregar Impuesto al Producto',
        articleId: this.idProducto // Pasar el ID del artículo (puede ser null si es nuevo)
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.newTax) {
        // Si el producto ya existe (tiene ID) y el impuesto se guardó en la API
        if (this.idProducto && result.saved && result.apiResponse) {
          const newTaxWithId = { ...result.newTax, id: result.apiResponse.id };
          this.productTaxes.push(newTaxWithId);
          this.openSnackBar(`Impuesto "${result.newTax.observations}" agregado correctamente`, 'Éxito');
        } 
        // Si es un producto nuevo (sin ID), agregar el impuesto solo localmente
        else if (!this.idProducto) {
          this.productTaxes.push(result.newTax);
          this.openSnackBar(`Impuesto "${result.newTax.observations}" agregado localmente. Se guardará con el producto.`, 'Info');
        }

        this.updateTaxesFormField();
        this.recalcularPreciosConNuevosImpuestos();
      }
    });
  }

  /**
   * Remueve un impuesto del producto
   */
  removeTaxFromProduct(index: number) {
    if (index >= 0 && index < this.productTaxes.length) {
      const removedTax = this.productTaxes[index];

      Swal.fire({
        title: '¿Está seguro de eliminar el impuesto?',
        text: `Esta acción recalculará los precios de venta del producto basados en los impuestos restantes. No podrá deshacer este cambio.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          // Si el impuesto tiene un ID de relación (ya existe en la BD), se elimina vía API
          if (removedTax.id) {
            this.productoService.deleteArticleTax(removedTax.id).subscribe({
              next: () => {
                // Eliminar del array local
                this.productTaxes.splice(index, 1);
                this.updateTaxesFormField();

                // Recalcular precios después de eliminar el impuesto
                this.recalcularPreciosConNuevosImpuestos();

                this.openSnackBar(`Impuesto "${removedTax.observations || removedTax.tax.desc}" eliminado`, 'Info');
              },
              error: (error) => {
                console.error('Error al eliminar impuesto:', error);
                this.openSnackBar('Error al eliminar el impuesto del servidor', 'Error');
              }
            });
          } else {
            // Si no tiene ID, es un impuesto recién agregado que no se ha guardado, se elimina solo localmente
            this.productTaxes.splice(index, 1);
            this.updateTaxesFormField();
            
            // Recalcular precios después de eliminar el impuesto
            this.recalcularPreciosConNuevosImpuestos();
            
            this.openSnackBar(`Impuesto "${removedTax.observations || removedTax.tax.desc}" eliminado localmente`, 'Info');
          }
        }
      });
    }
  }

  /**
   * Edita un impuesto del producto
   */
  editTaxFromProduct(productTax: any, index: number) {
    const dialogRef = this.dialog.open(ImpuestosDialogComponent, {
      width: '700px',
      maxWidth: '95vw',
      maxHeight: '80vh',
      data: {
        title: 'Editar Impuesto del Producto',
        articleId: this.idProducto,
        editMode: true,
        currentTax: productTax,
        taxIndex: index
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.saved && result.updatedTax) {
        // Actualizar el impuesto en el array
        this.productTaxes[index] = result.updatedTax;
        this.updateTaxesFormField();
        
        // Recalcular precios si hay valores en el formulario
        this.recalcularPreciosConNuevosImpuestos();
        
        this.openSnackBar(`Impuesto "${result.updatedTax.observations}" actualizado correctamente`, 'Éxito');
      }
    });
  }

  /**
   * Calcula el porcentaje total de impuestos
   */
  getTotalTaxPercentage(): number {
    if (!this.productTaxes || this.productTaxes.length === 0) {
      return 0;
    }
    const total = this.productTaxes.reduce((total, productTax) => {
      const percentage = parseFloat(productTax.percentage as any);
      return total + (isNaN(percentage) ? 0 : percentage);
    }, 0);
    // Redondear a 2 decimales
    return Math.round(total * 100) / 100;
  }

  /**
   * Recalcula los precios cuando se agregan nuevos impuestos
   */
  private recalcularPreciosConNuevosImpuestos() {
    const purchasePriceWithoutIva = Number(this.form.get('purchasePriceWithoutIva')?.value) || 0;
    const salePrice = Number(this.form.get('salePrice')?.value) || 0;
    
    // Solo recalcular si hay valores base
    if (purchasePriceWithoutIva > 0) {
      // Recalcular desde el costo base hacia adelante
      this.calcularPreciosHaciaAdelante();
    } else if (salePrice > 0) {
      // Recalcular desde el precio de venta hacia atrás
      this.calcularMargenDesdePrecios();
    }
  }

  /**
   * Carga los impuestos del artículo desde la API cuando se está editando
   */
  private loadArticleTaxesFromAPI() {
    if (!this.idProducto || this.idProducto <= 0) {
      return;
    }

    this.productoService.getArticleTaxes(this.idProducto).subscribe({
      next: (taxes) => {
        // Convertir los impuestos de la API al formato del componente
        this.productTaxes = taxes.map(tax => ({
          id: tax.id, // ID del ArticleTax para ediciones
          tax: {
            id: tax.taxId,
            code: '', // Se puede obtener de la tabla de tributos si es necesario
            idAfip: 0,
            desc: tax.name,
            importe: 0,
            baseImp: 0,
            alic: tax.taxPercentage,
            createdAt: '',
            updatedAt: '',
            deletedAt: ''
          } as Tributo,
          percentage: tax.taxPercentage,
          observations: tax.name
        }));
        
        // Actualizar el campo del formulario
        this.updateTaxesFormField();
        
        // FORZAR RECÁLCULO después de cargar impuestos
        setTimeout(() => {
          this.calcularPreciosHaciaAdelante();
        }, 100);
      },
      error: (error) => {
        console.error('Error al cargar impuestos desde API:', error);
        // Continuar con el método normal de carga desde JSON
        this.loadProductTaxesFromJSON();
      }
    });
  }

  /**
   * Carga los impuestos desde el campo JSON (método original)
   */
  private loadProductTaxesFromJSON() {
    const taxesData = this.form.get('taxes')?.value;
    this.loadProductTaxes(taxesData);
  }

  /**
   * Navega a la pestaña de impuestos para configurarlos
   */
  navegarAPestanaImpuestos(): void {
    try {
      if (this.tabGroup) {
        // La pestaña de "Impuestos" es siempre la última pestaña
        // Obtener el número total de pestañas y seleccionar la última
        const totalTabs = this.tabGroup._tabs?.length || 0;
        
        if (totalTabs > 0) {
          const impuestosTabIndex = totalTabs - 1;
          
          // Cambiar a la pestaña de impuestos (última pestaña)
          this.tabGroup.selectedIndex = impuestosTabIndex;
          
          // Mostrar notificación para guiar al usuario
          this._snackBar.open(
            'Pestaña de Impuestos activada. Configura los impuestos específicos del producto.',
            'Cerrar',
            {
              duration: 4000,
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: ['snack-info']
            }
          );
          
          console.log(`Navegando a pestaña de Impuestos (índice ${impuestosTabIndex} de ${totalTabs} pestañas)`);
        } else {
          throw new Error('No hay pestañas disponibles');
        }
      } else {
        console.warn('TabGroup no está disponible aún');
        // Fallback: scroll hacia la sección de impuestos
        this.scrollToImpuestosSection();
      }
    } catch (error) {
      console.error('Error al navegar a la pestaña de impuestos:', error);
      this.scrollToImpuestosSection();
    }
  }

  /**
   * Método fallback para hacer scroll hacia la sección de impuestos
   */
  private scrollToImpuestosSection(): void {
    const impuestosElement = document.querySelector('.card-header:has(h5:contains("Gestión de Impuestos"))') || 
                            document.querySelector('[aria-label*="Configurar impuestos"]');
    
    if (impuestosElement) {
      impuestosElement.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'start' 
      });
      
      this._snackBar.open(
        'Sección de impuestos localizada. Configura los impuestos del producto aquí.',
        'Cerrar',
        {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: ['snack-info']
        }
      );
    }
  }

  /**
   * Actualiza el campo del formulario con los impuestos del producto
   */
  private updateTaxesFormField() {
    // Crear un string JSON con los impuestos para guardar en el campo taxes
    const taxesData = JSON.stringify(this.productTaxes.map(pt => ({
      taxId: pt.tax.id,
      percentage: pt.percentage,
      code: pt.tax.code,
      desc: pt.tax.desc
    })));
    
    this.form.get('taxes')?.setValue(taxesData);
  }

  /**
   * Carga los impuestos del producto cuando se está editando
   */
  private loadProductTaxes(taxesData: string) {
    if (!taxesData || taxesData.trim() === '') {
      this.productTaxes = [];
      return;
    }

    try {
      const taxes = JSON.parse(taxesData);
      if (Array.isArray(taxes)) {
        this.productTaxes = taxes.map(taxData => ({
          tax: {
            id: taxData.taxId,
            code: taxData.code,
            desc: taxData.desc,
            nombre: taxData.desc,
            idAfip: 0,
            importe: 0,
            baseImp: 0,
            alic: taxData.percentage,
            createdAt: '',
            updatedAt: '',
            deletedAt: ''
          } as Tributo,
          percentage: taxData.percentage
        }));
      }
    } catch (error) {
      console.error('Error al parsear impuestos del producto:', error);
      this.productTaxes = [];
    }
  }

  /**
   * Alterna entre vista simplificada y avanzada para la sección de precios
   */
  toggleAdvancedPricing(): void {
    this.showAdvancedPricing = !this.showAdvancedPricing;
    
    // Mostrar feedback al usuario sobre el cambio de vista
    const mensaje = this.showAdvancedPricing 
      ? 'Vista avanzada activada: Todos los cálculos detallados son ahora visibles'
      : 'Vista simplificada activada: Solo los campos esenciales son visibles';
    
    this._snackBar.open(mensaje, 'Cerrar', {
      duration: 3000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: [this.showAdvancedPricing ? 'snack-info' : 'snack-success']
    });
  }

  /**
   * Selecciona todo el texto de un input cuando se hace clic en él
   */
  selectAllText(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input && input.select) {
      // Usar setTimeout para asegurar que el foco esté establecido
      setTimeout(() => {
        input.select();
      }, 0);
    }
  }

  /**
   * Redondea el valor de un campo de precio cuando pierde el foco
   */
  onPriceFieldBlur(event: Event, fieldName: string): void {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    
    if (value && value !== '') {
      const roundedValue = this.roundToTwoDecimals(value);
      this.form.get(fieldName)?.setValue(roundedValue, { emitEvent: true });
    }
  }

  /**
   * Genera tooltip detallado con todos los datos del cálculo paso a paso
   */
  getCalculationTooltip(): string {
    return `Método Cascada Inversa - Cálculo de Precios

🔢 PROCESO DE CÁLCULO:

1️⃣ PRECIO BASE:
   Se toma el Precio de Compra sin IVA como base del cálculo

2️⃣ APLICAR MARGEN:
   Precio con Margen = Precio Base × (1 + Margen ÷ 100)

3️⃣ AJUSTAR POR OTROS IMPUESTOS:
   Precio Neto = Precio con Margen ÷ (1 - Otros Impuestos ÷ 100)
   
   💡 Esta división "hacia atrás" garantiza que después de pagar
   los otros impuestos, mantengas tu margen de ganancia deseado

4️⃣ AGREGAR IVA:
   Precio Final = Precio Neto × (1 + IVA ÷ 100)

🎯 RESULTADO:
   Obtienes un precio que preserva tu margen real de ganancia
   incluso después de descontar todos los impuestos

📊 EJEMPLO:
   • Costo: $100 | Margen: 30% | Otros: 3% | IVA: 21%
   • Precio con margen: $130
   • Precio neto ajustado: $134.02 (130 ÷ 0.97)
   • Precio final: $162.17 (134.02 × 1.21)
   ✅ Tu ganancia real: $30 (30% sobre el costo)`;
  }

  /**
   * Abre el diálogo con la explicación completa del cálculo de precios
   */
  openCalculationDialog(): void {
    this.dialog.open(InfoDialogComponent, {
      width: 'auto',
      minWidth: '500px',
      maxWidth: '90vw',
      height: 'auto',
      panelClass: 'info-dialog',
      data: {
        title: 'Método de Cálculo de Precios',
        content: this.getCalculationTooltip(),
        icon: 'calculate'
      }
    });
  }

  /**
   * Abre el diálogo con la explicación del precio sin IVA
   */
  openPriceWithoutIvaDialog(): void {
    const content = `Se calcula aplicando el Margen de Ganancia al Costo Base y luego se ajusta para cubrir el costo de 'Otros Impuestos' (como IIBB).

Fórmula: (Costo con Margen) / (1 - % Otros Impuestos)

Este ajuste garantiza que después de pagar los otros impuestos, mantengas el margen de ganancia deseado sobre tu costo base.`;

    this.dialog.open(InfoDialogComponent, {
      width: 'auto',
      minWidth: '400px',
      maxWidth: '90vw',
      height: 'auto',
      panelClass: 'info-dialog',
      data: {
        title: 'Precio Venta sin IVA',
        content: content,
        icon: 'info'
      }
    });
  }


}
